export const InsuranceCompany = {
  Number: 'Number',
  ShortName: 'Short name',
};
